// extracted by mini-css-extract-plugin
module.exports = {"bg":"GameWrapper_bg__cfO77","body":"GameWrapper_body__3fTyL","barsik1":"GameWrapper_barsik1__3sTfX","hatir":"GameWrapper_hatir__1R9i4"};